import { render, staticRenderFns } from "./AboutUsPage.vue?vue&type=template&id=0ae9f34e"
import script from "./AboutUsPage.vue?vue&type=script&lang=js"
export * from "./AboutUsPage.vue?vue&type=script&lang=js"
import style0 from "./AboutUsPage.vue?vue&type=style&index=0&id=0ae9f34e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports